module.exports = __webpack_public_path__ + "img/Calendar_-_Blue.75a557df.png";